<div class="container-box">
  <app-table-header tableTitle="Accessori veicoli" (btnUpdateClick)="loadVehicleAccessory()">
    <app-button-new-vehicle-accessory action-button></app-button-new-vehicle-accessory>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="vehicleAccessoryTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
